"use strict";
var Observable_1 = require('../../Observable');
var timeInterval_1 = require('../../operator/timeInterval');
Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
//# sourceMappingURL=timeInterval.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/timeInterval.js
// module id = 1131
// module chunks = 3